import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { App as AntdApp, ConfigProvider } from 'antd';
import { store } from './store';
import App from './App';
import MessageHolder from './components/MessageHolder';
// Import preload utility for development
import './utils/preloadComponents';
import 'antd/dist/reset.css';
import './index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error("Root container missing in index.html");
}

const appTheme = {
  token: {
    colorPrimary: '#1A6FA8',
    colorSuccess: '#15803D',
    colorWarning: '#D97706',
    colorError: '#EF4444',
    colorInfo: '#1A6FA8',
    colorBgLayout: '#F8FAFC',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    colorBorder: '#E2E8F0',
    colorBorderSecondary: '#F1F5F9',
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: 13,
    colorText: '#334155',
    colorTextSecondary: '#64748B',
    colorTextTertiary: '#94A3B8',
    colorTextHeading: '#0F172A',
    boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
  },
  components: {
    Button: {
      borderRadius: 8,
      fontWeight: 600,
      primaryShadow: '0 2px 8px rgba(26,111,168,0.25)',
      paddingInline: 16,
    },
    Table: {
      headerBg: '#F8FAFC',
      headerColor: '#64748B',
      rowHoverBg: '#F0F7FF',
      borderColor: '#E2E8F0',
      cellPaddingBlock: 10,
      cellPaddingInline: 14,
      footerBg: '#F8FAFC',
      fontSize: 13,
    },
    Card: {
      borderRadius: 14,
      boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
      paddingLG: 20,
    },
    Input: {
      borderRadius: 8,
      paddingBlock: 7,
      paddingInline: 12,
      activeShadow: '0 0 0 3px rgba(26,111,168,0.1)',
    },
    Select: { borderRadius: 8 },
    Modal: { borderRadiusLG: 16 },
    Tag: { borderRadius: 20 },
    Menu: {
      itemColor: '#64748B',
      itemSelectedColor: '#1A6FA8',
      itemSelectedBg: '#EFF6FF',
      itemHoverColor: '#1A6FA8',
      itemHoverBg: '#F0F7FF',
    },
    Layout: {
      headerBg: '#FFFFFF',
      headerHeight: 56,
      siderBg: '#FFFFFF',
      bodyBg: '#F8FAFC',
    },
  },
};

const AppWithRedux = () => {
  return (
    <Provider store={store}>
      <ConfigProvider theme={appTheme}>
        <AntdApp>
          <MessageHolder />
          <App />
        </AntdApp>
      </ConfigProvider>
    </Provider>
  );
};

const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <AppWithRedux />
  </React.StrictMode>
);
